const INT32_NEGATIVE_MAX_VALUE = -2147483647;

const alerts = [
  { id: 1, timeToExpirationStart: 61, timeToExpirationEnd: 90 },
  { id: 2, timeToExpirationStart: 31, timeToExpirationEnd: 60 },
  { id: 3, timeToExpirationStart: 16, timeToExpirationEnd: 30 },
  { id: 4, timeToExpirationStart: 11, timeToExpirationEnd: 15 },
  { id: 5, timeToExpirationStart: 6, timeToExpirationEnd: 10 },
  { id: 6, timeToExpirationStart: 1, timeToExpirationEnd: 5 },
  {
    id: 7,
    timeToExpirationStart: INT32_NEGATIVE_MAX_VALUE,
    timeToExpirationEnd: -1
  }
];

export default alerts;
